<aside id="cta-button-sidebar"
  class="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full border-r sm:translate-x-0 bg-blue-50/30 backdrop-blur-lg border-blue-100/50"
  aria-label="Sidebar">

  <!-- Banderole des couleurs du Gabon -->
  <div class="flex w-full h-2">
    <div class="w-[33%] bg-green-600"></div>
    <div class="w-[33%] bg-yellow-400"></div>
    <div class="w-[34%] bg-blue-800"></div>
  </div>

  <div class="h-full px-3 py-4 overflow-y-auto">
    <ul class="mt-8 space-y-2 font-medium">
      <li *ngIf="role === 'INSPECTEUR_PRINCIPAL' || role === 'SUPER_ADMIN'">
        <a routerLink="vueEnsemble" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path fill-rule="evenodd"
              d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm4.5 7.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0V12Zm2.25-3a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0V9.75A.75.75 0 0 1 13.5 9Zm3.75-1.5a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0v-9Z"
              clip-rule="evenodd" />
          </svg>
          <span class="text-gray-800 ms-3">Dashboard</span>
        </a>
      </li>

      <li *ngIf="role=='SUPER_ADMIN' || role === 'DIRECTEUR_TECHNIQUE' || role === 'CHEF_SEVICE_TECHNIQUE'">
        <a routerLink="vue-ensemble" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="text-gray-800 size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z" />
          </svg>

          <span class="text-gray-800 ms-3">Vue d'Ensemble</span>
        </a>
      </li>

      <li *ngIf="role === 'CONTROLLEUR' || role === 'SUPER_ADMIN' || role === 'INSPECTEUR_PRINCIPAL'">
        <a routerLink="inspection/collection" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path
              d="M5.223 2.25c-.497 0-.974.198-1.325.55l-1.3 1.298A3.75 3.75 0 0 0 7.5 9.75c.627.47 1.406.75 2.25.75.844 0 1.624-.28 2.25-.75.626.47 1.406.75 2.25.75.844 0 1.623-.28 2.25-.75a3.75 3.75 0 0 0 4.902-5.652l-1.3-1.299a1.875 1.875 0 0 0-1.325-.549H5.223Z" />
            <path fill-rule="evenodd"
              d="M3 20.25v-8.755c1.42.674 3.08.673 4.5 0A5.234 5.234 0 0 0 9.75 12c.804 0 1.568-.182 2.25-.506a5.234 5.234 0 0 0 2.25.506c.804 0 1.567-.182 2.25-.506 1.42.674 3.08.675 4.5.001v8.755h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3Zm3-6a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3Zm8.25-.75a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75h-3Z"
              clip-rule="evenodd" />
          </svg>
          <span class="text-gray-800 ms-3">Rapport d'Inspection</span>
        </a>
      </li>

      <li *ngIf="role === 'CONTROLLEUR' || role === 'SUPER_ADMIN' || role === 'INSPECTEUR_PRINCIPAL'">
        <a routerLink="badge/collection" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path fill-rule="evenodd"
              d="M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm4.125 3a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-3.873 8.703a4.126 4.126 0 0 1 7.746 0 .75.75 0 0 1-.351.92 7.47 7.47 0 0 1-3.522.877 7.47 7.47 0 0 1-3.522-.877.75.75 0 0 1-.351-.92ZM15 8.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15ZM14.25 12a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15Z"
              clip-rule="evenodd" />
          </svg>
          <span class="flex-1 text-gray-800 ms-3 whitespace-nowrap">Carte
            d'Inspection</span>
        </a>
      </li>

      <li *ngIf="role === 'INSPECTEUR_PRINCIPAL' || role === 'SUPER_ADMIN'">
        <a routerLink="users" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path fill-rule="evenodd"
              d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
              clip-rule="evenodd" />
          </svg>
          <span class="text-gray-800 ms-3">Gérer les inspecteurs</span>
        </a>
      </li>

      <li *ngIf="role=='SUPER_ADMIN'">
        <a routerLink="partenaires-technique" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path
              d="M11.584 2.376a.75.75 0 0 1 .832 0l9 6a.75.75 0 1 1-.832 1.248L12 3.901 3.416 9.624a.75.75 0 0 1-.832-1.248l9-6Z" />
            <path fill-rule="evenodd"
              d="M20.25 10.332v9.918H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h.75v-9.918a.75.75 0 0 1 .634-.74A49.109 49.109 0 0 1 12 9c2.59 0 5.134.202 7.616.592a.75.75 0 0 1 .634.74Zm-7.5 2.418a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Zm3-.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0v-6.75a.75.75 0 0 1 .75-.75ZM9 12.75a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Z"
              clip-rule="evenodd" />
            <path d="M12 7.875a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z" />
          </svg>
          <span class="text-gray-800 ms-3">Partenaires Techniques</span>
        </a>
      </li>

      <li>
        <a routerLink="profil" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path fill-rule="evenodd"
              d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
              clip-rule="evenodd" />
          </svg>
          <span class="flex-1 ms-3 whitespace-nowrap">Profil</span>
        </a>
      </li>

      <!-- <li *ngIf="role=='DGMG'">
        <a routerLink="utilisateurs/ajout"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="currentColor" class="text-gray-800 size-5">
            <path
              d="M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0 1.5h-2.25V7.5Z" />
          </svg>
          <span class="flex-1 ms-3 whitespace-nowrap">Gérer les
            Inspecteurs</span>
        </a>
      </li> -->

      <li *ngIf="role=='SUPER_ADMIN' || role=='INSPECTEUR_PRINCIPAL'">
        <a routerLink="manage-licence" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg cursor-pointer hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path d="M12 7.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" />
            <path fill-rule="evenodd"
              d="M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 14.625v-9.75ZM8.25 9.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM18.75 9a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75h-.008ZM4.5 9.75A.75.75 0 0 1 5.25 9h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V9.75Z"
              clip-rule="evenodd" />
            <path
              d="M2.25 18a.75.75 0 0 0 0 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 0 0-.75-.75H2.25Z" />
          </svg>
          <span class="flex-1 ms-3 whitespace-nowrap">Gérer les licences</span>
        </a>
      </li>
      <li *ngIf="role=='INSPECTEUR_PRINCIPAL' || role=='DIRECTEUR_TECHNIQUE' || role=='CHEF_SEVICE_TECHNIQUE'">
        <a routerLink="demand-licence" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg cursor-pointer hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path fill-rule="evenodd"
              d="M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.25 6a.75.75 0 0 0-1.5 0v4.94l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V9.75Z"
              clip-rule="evenodd" />
          </svg>

          <span class="flex-1 ms-3 whitespace-nowrap">Demande de licences</span>
        </a>
      </li>

      <li>
        <a routerLink="parametre" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg cursor-pointer hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path
              d="M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z" />
            <path fill-rule="evenodd"
              d="M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z"
              clip-rule="evenodd" />
          </svg>

          <span class="flex-1 ms-3 whitespace-nowrap">Paramètres</span>
        </a>
      </li>
      <li *ngIf="role=='SUPER_ADMIN' || role === 'DIRECTEUR_TECHNIQUE' || role === 'CHEF_SEVICE_TECHNIQUE'">
        <a routerLink="aide" [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="!bg-blue-100/50 !text-blue-800 border-l-4 border-blue-600 font-medium"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg cursor-pointer hover:bg-blue-100/40 group">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path fill-rule="evenodd"
              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
              clip-rule="evenodd" />
          </svg>


          <span class="flex-1 ms-3 whitespace-nowrap">Aide</span>
        </a>
      </li>
      <li>
        <a (click)="showConfirmationModal = true"
          class="flex items-center p-3 text-gray-800 transition-colors duration-200 rounded-lg cursor-pointer hover:bg-blue-100/40 group">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 size-5">
            <path
              d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" />
          </svg>
          <span class="flex-1 ms-3 whitespace-nowrap">Se déconnecter</span>
        </a>
      </li>

    </ul>
  </div>

  <!-- Section version fixée en bas -->
  <div class="fixed bottom-0 p-4 border-t border-blue-100/50 bg-blue-50/20">
    <div class="flex items-center justify-between text-sm text-gray-600">
      <span class="text-sm text-gray-800">Version: 0.0.1</span>&nbsp;&nbsp;
      <span class="text-sm text-gray-800">&copy; {{ year }} prolab Afrik</span>
    </div>
    <div class="mt-1">
      <span class="px-2 py-1 text-xs font-medium text-green-800 bg-green-100 rounded-full">
        Production
      </span>
    </div>
  </div>
</aside>

<div *ngIf="showConfirmationModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="p-6 bg-white border border-gray-200 rounded-lg shadow-lg w-96">
    <h3 class="mb-4 text-xl font-semibold text-gray-800">Confirmer l'action</h3>
    <p class="text-gray-600">
      Êtes-vous sûr de vouloir vous déconnecter ?
    </p>
    <div class="flex justify-end mt-6 space-x-3">
      <button (click)="showConfirmationModal = false"
        class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button routerLink="login"
        class="px-4 py-2 text-white bg-red-600 border border-red-700 rounded-lg hover:bg-red-700">
        Confirmer
      </button>
    </div>
  </div>
</div>
